const ILLEGAL_CHAR_PATTERN = '[\\s<>/[\\]~:+%\\\\]';
const ILLEGAL_CHAR_REGEX = new RegExp(ILLEGAL_CHAR_PATTERN, 'g');
/**
 * Convert filename to server friendly filename
 */
export function toServerFriendlyFilename(filename) {
    return filename.replace(ILLEGAL_CHAR_REGEX, '_');
}
/**
 * Assert that filename given is valid
 */
export function assertValidFilename(filename) {
    if (filename === '' || filename === undefined) {
        throw new Error('Filename is missing');
    }
    if (toServerFriendlyFilename(filename) !== filename) {
        throw new Error(`Filename contains illegal characters (${ILLEGAL_CHAR_PATTERN})`);
    }
}
/**
 * Parse filename for upload asset
 */
export function parseFilename(asset) {
    return asset.filename || 'image.' + asset.type.split('/').pop();
}
